import { Avatar, Box, Grid, Typography } from "@mui/material";
import React from "react";
import { escapeDanger, formatTimeAgo } from "../../utilities/function";
import Loading from "../../components/Loading";
import { BackgroundColor, Color } from "../../services/stickerColor";
import { useNavigate } from "react-router-dom";
import Image from "../../components/Image";

const Activity = ({ activities, members }) => {
  const navigate = useNavigate();

  const activityTypePage = {
    member: "/organization-user",
    organization: "/organizations",
    project: "/projects",
  };

  const IssueType = {
    Bug: "bug.png",
    Task: "Task.png",
    Subtask: "subTask.png",
  };
  return (
    <>
      {activities ? (
        activities?.map((activity, i) => {
          const currentTime = new Date();
          const activiteTime = new Date(activity.time);
          const differenceInMilliseconds = currentTime - activiteTime;
          const formattedTimeAgo = formatTimeAgo(differenceInMilliseconds);
           // console.log(activity, "activity");

          return (
            <Grid
              key={i}
              container
              spacing={2}
              alignItems="start"
              flexWrap="nowrap"
              mb={2}
              py={1}
            >
              <Grid item>
                <Image
                  name={IssueType[activity.type] || (activity.type === "project" ? "project.png" : "comment.png")}
                  sx={{ width: 16, height: 16, mr: 1 }}
                />
              </Grid>
              <Grid
                item
                xs
                sx={{
                  minWidth: "0",
                  cursor: "pointer",
                }}
                // onClick={() =>
                // navigate(
                //     activity.type === 'issue' ||
                //         activity.type === 'comment'
                //         ? `/projects/${activity.correspondId?.project}/board?issues=${activity.correspondId?.issue}`
                //         : activityTypePage[activity.type]
                // )
                // }
              >
                <Box
                  sx={{
                    display: "flex",
                    flexFlow: "row nowrap",
                    position: "relative",
                    minHeight: "100%",
                    minWidth: "0",
                  }}
                >
                  <span
                    style={{
                      fontSize: "14px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: escapeDanger(activity.description),
                    }}
                  />
                  {/* <Box
                    sx={{
                      backgroundColor: BackgroundColor[activity.type],
                      color: Color[activity.type],
                      fontWeight: 600,
                      borderRadius: "4px",
                      textTransform: "capitalize",
                      px: 0.4,
                      fontSize: 13,
                      ml: 1,
                    }}
                  >
                    {activity.type}
                  </Box> */}
                  {activity.status ? (
                    <Box
                      sx={{
                        border: "1px solid #e0e0e0",
                        backgroundColor: "#f5f5f5",
                        color: "#555",
                        fontWeight: 600,
                        borderRadius: "4px",
                        textTransform: "capitalize",
                        px: 0.4,
                        fontSize: 12,
                        ml: 1,
                      }}
                    >
                      {activity.status}
                    </Box>
                  ) : null}
                </Box>
                {/* <Typography
                                    variant='body2'
                                    fontSize='12px'
                                    color='text.secondary'>
                                    {activity.fullName}
                                </Typography> */}
              </Grid>
              <Grid item textAlign="center">
                <Typography variant="caption" color="text.secondary">
                  {formattedTimeAgo}
                </Typography>
              </Grid>
            </Grid>
          );
        })
      ) : (
        <Loading />
      )}
    </>
  );
};

export default Activity;
